function initProductGallery(gallery) {
  const track = gallery.querySelector('[data-product-gallery-track]');
  const thumbs = gallery.querySelectorAll('[data-product-gallery-thumb-index]');
  const nextBtn = gallery.querySelectorAll(
    '[data-product-gallery-control-next]'
  );
  const prevBtn = gallery.querySelectorAll(
    '[data-product-gallery-control-prev]'
  );
  const currentDisplay = gallery.querySelector(
    '[data-product-gallery-index-current]'
  );
  const totalDisplay = gallery.querySelector(
    '[data-product-gallery-index-total]'
  );
  let currentIndex = 1;
  const totalImages = thumbs.length;
  let scrollTo = 0;
  let isScrolling = false;
  const scrollMode = 'instant'; // 'instant' or 'smooth'

  // set total
  totalDisplay.textContent = totalImages;

  function emitChange() {
    const image = track.querySelector(
      '[data-product-gallery-image="' + currentIndex + '"]'
    );
    const imageId = image?.getAttribute('data-product-gallery-image-id') ?? '';

    gallery.dispatchEvent(
      new CustomEvent('product-gallery:change', {
        bubbles: true,
        detail: {
          index: currentIndex,
          imageId,
        },
      })
    );
  }

  // set image
  function setImage(index, { emit = true } = {}) {
    const parsedIndex = parseInt(index, 10);
    if (parsedIndex === currentIndex) {
      updateDisplays({ emit: false });
      return;
    }

    currentIndex = parsedIndex;
    const image = track.querySelector(
      '[data-product-gallery-image="' + parsedIndex + '"]'
    );
    const imageWidth = image.offsetWidth;

    // scroll to image
    isScrolling = true;
    const scrollLeft = (parsedIndex - 1) * imageWidth;
    scrollTo = scrollLeft;
    track.scrollTo({
      left: scrollLeft,
      behavior: scrollMode,
    });

    updateDisplays({ emit });
  }

  // update displays
  function updateDisplays({ emit = true } = {}) {
    // update text displays
    currentDisplay.textContent = currentIndex;
    totalDisplay.textContent = totalImages;

    // update thumb element styles
    const thumb = gallery.querySelector(
      '[data-product-gallery-thumb-index="' + currentIndex + '"]'
    );
    thumbs.forEach((thumb) => {
      thumb.setAttribute('data-active', 'false');
    });
    thumb.setAttribute('data-active', 'true');

    if (emit) emitChange();
  }

  // detect index
  function detectIndex() {
    // Check the scroll position of the track and find the current index
    const imageWrappers = track.querySelectorAll(
      '[data-product-gallery-image]'
    );
    if (imageWrappers.length === 0) return 1;

    const trackScrollLeft = track.scrollLeft;
    let closestIndex = 1;
    let minDiff = Infinity;

    imageWrappers.forEach((wrapper) => {
      const idx = parseInt(
        wrapper.getAttribute('data-product-gallery-image'),
        10
      );
      const left = wrapper.offsetLeft;
      const diff = Math.abs(left - trackScrollLeft);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = idx;
      }
    });

    return closestIndex;
  }

  // scroll tracking
  let scrollTimeout;
  track.addEventListener('scroll', () => {
    if (!isScrolling || (isScrolling && track.scrollLeft === scrollTo)) {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
        const index = detectIndex();
        if (index === currentIndex) {
          updateDisplays({ emit: false });
          return;
        }

        currentIndex = index;
        updateDisplays();
      }, 50);
    }
  });

  // thumbs
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = thumb.getAttribute('data-product-gallery-thumb-index');
      setImage(index);
    });
  });

  // next button
  nextBtn.forEach((control) => {
    control.addEventListener('click', () => {
      let newIndex = currentIndex + 1;
      if (newIndex > totalImages) newIndex = 1;
      setImage(newIndex);
    });
  });

  // previous button
  prevBtn.forEach((control) => {
    control.addEventListener('click', () => {
      let newIndex = currentIndex - 1;
      if (newIndex < 1) newIndex = totalImages;
      setImage(newIndex);
    });
  });

  // initial image
  setImage(1, { emit: false });
}

document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach((gallery) => {
    initProductGallery(gallery);
  });
});
